import Vue from "vue";
import VueRouter from "vue-router";
import GlobalGuards from "@/guards/Global";
import label from "@/lang/StaticLabels.js";

import TheMain from "@/containers/TheMain";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "MainContainer",
    component: TheMain,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        meta: {
          label: "اطلاعیه",
          requiresAuth: true,
        },
        component: () => import("@/views/pages/Home"),
      },
      {
        path: "notice",
        name: "Notice",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/notice/add",
        children: [
          {
            path: "add",
            name: "AddNotice",
            meta: {
              label: "ثبت اطلاعیه",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/notice/Add"),
          },
          {
            path: "edit/:id",
            name: "EditNotice",
            meta: {
              label: "ویرایش اطلاعیه",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/notice/Add"),
          },
          {
            path: "archive",
            name: "ArchiveNotice",
            meta: {
              label: "بایگانی",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/notice/Archive"),
          },
          {
            path: "managerArchive",
            name: "ManagerArchive",
            meta: {
              label: "بایگانی موارد تایید شده مدیر",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/notice/ManagerArchive"),
          },
          {
            path: "confirm",
            name: "ConfirmNotice",
            meta: {
              label: "اطلاعیه های تأیید نشده (مدیر)",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/notice/Confirm"),
          },
          {
            path: "expert",
            name: "ExpertNotice",
            meta: {
              label: "اطلاعیه های تأیید نشده (کارشناس)",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/notice/Expert"),
          },
          {
            path: "details/:id",
            name: "NoticeDetails",
            meta: {
              label: "جزئیات اطلاعیه",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/notice/Details"),
          },
          {
            path: "manager/details/:id",
            name: "ManagerNoticeDetails",
            meta: {
              label: "جزئیات اطلاعیه (مدیر)",
              requiresAuth: true,
            },
            component: () => import("@/views/pages/notice/ManagerDetails"),
          },
        ],
      },

      {
        path: "user",
        name: "User",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/user/info",
        children: [
          {
            path: "info",
            name: "UserInfo",
            component: () => import("@/views/pages/user/index"),
            meta: {
              label: "کارمند",
              requiresAuth: true,
            },
          },
          {
            path: "group",
            name: "UserGroup",
            component: () => import("@/views/pages/user/Group"),
            meta: {
              label: "گروه های کاربری",
              requiresAuth: true,
            },
          },
          {
            path: "group/members/:id",
            name: "UserGroupMembers",
            component: () => import("@/views/pages/user/Member"),
            meta: {
              label: "کاربران گروه",
              requiresAuth: true,
            },
          },
        ],
      },

      {
        path: "support",
        name: "Support",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/support/menu",
        children: [
          {
            path: "menu",
            name: "SupportMenu",
            component: () => import("@/views/pages/support/index"),
            meta: {
              label: "پشتیبانی",
              requiresAuth: true,
            },
          },
          {
            path: "transport",
            name: "Transport",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/transport",
            children: [
              {
                path: "list",
                name: "TransportList",
                meta: {
                  label: "سرویس ایاب و ذهاب",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/support/transport"),
              },
              {
                path: "stations/:id",
                name: "Stations",
                meta: {
                  label: "",
                  requiresAuth: true,
                },
                component: () =>
                  import("@/views/pages/support/transport/Stations"),
              },
            ],
          },
          {
            path: "gifts",
            name: "Gifts",
            component: () => import("@/views/pages/support/gifts"),
            meta: {
              label: "ارزاق اهدایی",
              requiresAuth: true,
            },
          },
          {
            path: "food",
            name: "Food",
            component: () => import("@/views/pages/support/food"),
            meta: {
              label: "برنامه غذایی",
              requiresAuth: true,
            },
          },
          {
            path: "calendar",
            name: "Calendar",
            component: () => import("@/views/pages/support/calendar"),
            meta: {
              label: "تقویم کاری",
              requiresAuth: true,
            },
          },
        ],
      },

      {
        path: "hr",
        name: "HR",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/hr/menu",
        children: [
          {
            path: "menu",
            name: "HRMenu",
            component: () => import("@/views/pages/hr/index"),
            meta: {
              label: "اداری",
              requiresAuth: true,
            },
          },
          {
            path: "leaveRequest",
            name: "LeaveRequest",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/leaveRequest",
            children: [
              {
                path: "list",
                name: "LeaveRequestList",
                meta: {
                  label: "درخواست مرخصی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/leaveRequest"),
              },
              {
                path: "confirm",
                name: "LeaveRequestConfirmList",
                meta: {
                  label: "درخواست مرخصی (مدیر)",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/leaveRequest/Confirm"),
              },
              {
                path: "add",
                name: "AddLeaveRequest",
                meta: {
                  label: "ثبت درخواست مرخصی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/leaveRequest/Add"),
              },
              {
                path: "edit/:id",
                name: "EditLeaveRequest",
                meta: {
                  label: "ویرایش درخواست مرخصی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/leaveRequest/Add"),
              },
            ],
          },
          {
            path: "mission",
            name: "Mission",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/mission",
            children: [
              {
                path: "list",
                name: "MissionList",
                meta: {
                  label: "ماموریت",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/mission"),
              },
              {
                path: "confirm",
                name: "ManagerMissionList",
                meta: {
                  label: "ماموریت (مدیر)",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/mission/Confirm"),
              },
              {
                path: "add",
                name: "AddMission",
                meta: {
                  label: "ثبت درخواست ماموریت",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/mission/Add"),
              },
              {
                path: "edit/:id",
                name: "EditMission",
                meta: {
                  label: "ویرایش درخواست ماموریت",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/mission/Add"),
              },
            ],
          },
          {
            path: "extraWork",
            name: "ExtraWork",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/extraWork",
            children: [
              {
                path: "list",
                name: "ExtraWorkList",
                meta: {
                  label: "اضافه کار",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/extraWork"),
              },
              {
                path: "confirm",
                name: "ManagerExtraWorkList",
                meta: {
                  label: "اضافه کار (مدیر)",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/extraWork/Confirm"),
              },
              {
                path: "add",
                name: "AddExtraWork",
                meta: {
                  label: "ثبت درخواست اضافه کار",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/extraWork/Add"),
              },
              {
                path: "edit/:id",
                name: "EditExtraWork",
                meta: {
                  label: "ویرایش درخواست اضافه کار",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/extraWork/Add"),
              },
            ],
          },
          {
            path: "remainLeave",
            name: "RemainLeave",
            component: () => import("@/views/pages/hr/remainLeave"),
            meta: {
              label: "مانده مرخصی",
              requiresAuth: true,
            },
          },
          {
            path: "insurance",
            name: "Insurance",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/insurance",
            children: [
              {
                path: "list",
                name: "InsuranceList",
                meta: {
                  label: "بیمه تکمیلی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/insurance"),
              },
              {
                path: "fee",
                name: "InsuranceFee",
                meta: {
                  label: "تعرفه بیمه تکمیلی ",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/insurance/Fee"),
              },
            ],
          },
          {
            path: "dailyWork",
            name: "DailyWork",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/dailyWork",
            children: [
              {
                path: "list",
                name: "DailyWorkList",
                meta: {
                  label: "کارکرد",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/dailyWork/index"),
              },
              {
                path: "confirm",
                name: "ManagerForgetList",
                meta: {
                  label: "تردد ناقص (مدیر)",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/dailyWork/Confirm"),
              },
              {
                path: "expert",
                name: "ExpertForgetList",
                meta: {
                  label: "تردد ناقص (کارشناس)",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/dailyWork/Expert"),
              },
              {
                path: "add",
                name: "AddDailyWork",
                meta: {
                  label: "ثبت ورود و خروج فراموش شده",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/dailyWork/Add"),
              },
              {
                path: "edit/:id",
                name: "EditDailyWork",
                meta: {
                  label: "ویرایش تردد ناقص",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/dailyWork/Add"),
              },
            ],
          },
          {
            path: "cr",
            name: "Cr",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/cr",
            children: [
              {
                path: "list",
                name: "CrList",
                meta: {
                  label: "انتقادات و پیشنهادات",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/cr"),
              },
              {
                path: "confirm",
                name: "ManagerCrList",
                meta: {
                  label: "انتقادات و پیشنهادات (مدیر)",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/cr/Confirm"),
              },
              {
                path: "add",
                name: "AddCr",
                meta: {
                  label: "ثبت انتقادات و پیشنهادات",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/cr/Add"),
              },
              {
                path: "edit/:id",
                name: "EditCr",
                meta: {
                  label: "ویرایش انتقادات و پیشنهادات",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/cr/Add"),
              },
              {
                path: "answer/:id",
                name: "AddCrAnswer",
                meta: {
                  label: "ثبت نتیجه",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/cr/AddAnswer"),
              },
              {
                path: "show/:id",
                name: "ShowCrDetails",
                meta: {
                  label: "نمایش انتقادات و پیشنهادات",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/cr/Show"),
              },
            ],
          },
          {
            path: "poll",
            name: "Poll",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/poll",
            children: [
              {
                path: "list",
                name: "PollList",
                meta: {
                  label: "نظرسنجی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/index"),
              },
              {
                path: "manager/list",
                name: "ManagerPollList",
                meta: {
                  label: "نظرسنجی (مدیر)",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/Confirm"),
              },
              {
                path: "expert/list",
                name: "ExpertPollList",
                meta: {
                  label: "نظرسنجی (کارشناس)",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/Expert"),
              },
              {
                path: "answer/:id",
                name: "PollAnswer",
                meta: {
                  label: "پاسخ به نظرسنجی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/PollAnswer"),
              },
              {
                path: "update/:id",
                name: "UpdatePoll",
                meta: {
                  label: "مدیریت نظرسنجی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/Update"),
              },
              {
                path: "question/:headerId/:id",
                name: "AddQuestion",
                meta: {
                  label: "ثبت سوال نظرسنجی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/AddQuestion"),
              },
              {
                path: "question/:headerId/:catId/:id",
                name: "EditQuestion",
                meta: {
                  label: "ویرایش سوال نظرسنجی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/AddQuestion"),
              },
              {
                path: "result/list",
                name: "ResultPollList",
                meta: {
                  label: "نظرسنجی های پاسخ داده شده",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/Result"),
              },
              {
                path: "result/:id",
                name: "ResultPollItem",
                meta: {
                  label: "گزارش پاسخ های نظرسنجی",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/ResultDetail"),
              },
              {
                path: "managerPollDetails/:id",
                name: "ManagerPollDetails",
                meta: {
                  label: "جزئیات نظرسنجی مدیر",
                  requiresAuth: true,
                },
                component: () => import("@/views/pages/hr/poll/ManagerPollDetails"),
              },
            ],
          },
        ],
      },

      {
        path: "finance",
        name: "Finance",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/finance/menu",
        children: [
          {
            path: "menu",
            name: "FinanceMenu",
            component: () => import("@/views/pages/finance/index"),
            meta: {
              label: "مالی",
              requiresAuth: true,
            },
          },
          {
            path: "bill",
            name: "Bill",
            component: () => import("@/views/pages/finance/bill"),
            meta: {
              label: "فیش حقوقی",
              requiresAuth: true,
            },
          },
          {
            path: "loan",
            name: "Loan",
            component: () => import("@/views/pages/finance/loan"),
            meta: {
              label: "وام پرسنلی",
              requiresAuth: true,
            },
          },
          {
            path: "parts",
            name: "Parts",
            component: () => import("@/views/pages/finance/parts"),
            meta: {
              label: "اقلام تحویل شده",
              requiresAuth: true,
            },
          },
          {
            path: "reward",
            name: "Reward",
            component: () => import("@/views/pages/finance/reward"),
            meta: {
              label: "پاداش",
              requiresAuth: true,
            },
          },
        ],
      },


      // end of main container
    ],
  },

  // other Pages - without container
  {
    path: "/login",
    name: "Login",
    meta: {
      label: label.page.login,
    },
    component: () => import("@/views/auth/Login"),
    beforeEnter(to, from, next) {
      GlobalGuards.login(to, from, next);
    },
  },
  {
    path: "/forgot",
    name: "ForgotPassword",
    meta: {
      label: label.page.forgot,
    },
    component: () => import("@/views/auth/Forgot"),
   
  },

  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "underConstruction",
        name: "PageUnderConstruction",
        component: PageUnderConstruction,
      },
    ],
  },

  {
    path: "*",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

// router.beforeEach((to, from, next) => GlobalGuards.beforeEach(to, from, next));
// router.afterEach((to, from) => GlobalGuards.afterEach(to, from));

export default router;
